import { useState, useEffect } from "react";
import api from "../../services/api";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faSquarePlus, faSquareMinus } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import EditModal from "../ui/EditModal.js";
import { normalizar } from "../../common/stringNormalizer.js";

export default function AddTipoDocumento() {
  const [filtroEstado, setFiltroEstado] = useState("activas");
  const [tipoDoc, setTipoDoc] = useState("");
  const [idPais, setIdPais] = useState("");
  const [paises, setPaises] = useState([]);
  const [tipos, setTipos] = useState([]);
  const [selectedTipo, setSelectedTipo] = useState(null);

  useEffect(() => {
    fetchPaises();
    fetchTipos();
  }, []);

  const editFields = [
    { name: "TipoDocumento", label: "Tipo Documento", type: "text", required: true },
    { name: "IdPais", label: "País", type: "select", required: true, options: paises.map(p => ({ value: p.IdPais, label: p.Nombre })) }
  ];

  const fetchPaises = async () => {
    try {
      const resp = await api.get(`/paises`);
      const activos = resp.data.filter(p => p.estado === 1);
      setPaises(activos);

      // Preseleccionar Argentina si existe
      const argentina = activos.find(p => p.Nombre.toLowerCase().includes("argentina"));
      if (argentina) setIdPais(argentina.IdPais);
    } catch (error) {
      console.error("Error cargando países:", error);
    }
  };

  const fetchTipos = async () => {
    try {
      const resp = await api.get(`/tipodocumentos`);
      setTipos(resp.data);
    } catch (error) {
      console.error("Error cargando tipos de documento:", error);
    }
  };

  const filtrarTipos = () => {
  if (filtroEstado === "activas") return tipos.filter(t => t.estado === 1);
  if (filtroEstado === "inactivas") return tipos.filter(t => t.estado === 0);
  return tipos;
};

  const createTipo = async e => {
    e.preventDefault();

    const existe = tipos.some(
      (patologia) => normalizar(patologia.TipoDocumento) === normalizar(tipoDoc)
    );

    if (existe) {
      Swal.fire({
        icon: "warning",
        title: "Duplicado",
        text: "Ya existe un tipo de documento con ese nombre.",
        confirmButtonColor: "#3085d6"
      });
      return;
    }

    try {
      await api.post(`/tipodocumentos`, {
        IdPais: idPais,
        TipoDocumento: tipoDoc
      });

      setTipoDoc("");
      fetchTipos();

      Swal.fire({
        icon: "success",
        title: "Guardado",
        text: "El tipo de documento fue guardado exitosamente.",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error creando tipo documento:", error);
      Swal.fire({
        icon: "error",
        title: "Error al guardar",
        text: "Ocurrió un problema al guardar el tipo de documento.",
      });
    }
  };

  const handleEditTipoDocumento = async (values) => {
    try {
      await api.patch(
        `/tiposDocumentos/updateTipoDocumeto/${values.idTipoDocumento}`,
        { IdPais: values.IdPais, Nombre: values.TipoDocumento }
      );
      Swal.fire({
        icon: "success",
        title: "Tipo de documento actualizado",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (error) {
      console.error("Error al actualizar:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al actualizar el tipo de documento.",
      });
    }
    setSelectedTipo(null);
    fetchTipos();
  };

 const toggleEstado = async id => {
  try {
     await api.patch(`/tipodocumentos/cambiarEstadoDocumento/${id}`);
    fetchTipos();
    Swal.fire({
      icon: "success",
      title: "Estado actualizado",
      text: "El estado del tipo de documento fue cambiado exitosamente.",
      timer: 1500,
      showConfirmButton: false
    });
  } catch (error) {
    console.error("Error cambiando estado:", error);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "No se pudo cambiar el estado del tipo de documento.",
    });
  }
};

  const columns = [
    {
      name: "Nombre",
      selector: row => row.TipoDocumento,
      sortable: true
    },
    {
      name: "País",
      selector: row => row.Nombre,
      sortable: true
    },
    {
      name: "Editar",
      cell: row => (
        <button
          className="button is-small is-info"
          onClick={() => setSelectedTipo(row)}
        >
          <FontAwesomeIcon icon={faPencil} />
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      compact: true
    },
    {
      name: "Activo",
      cell: row =>
        row.estado === 1 ? (
          <FontAwesomeIcon icon={faSquarePlus} style={{ color: "#37ff00", cursor: "pointer" }} size="2xl" onClick={() => toggleEstado(row.idTipoDocumento)}
          />
        ) : (
          <FontAwesomeIcon icon={faSquareMinus} style={{ color: "#ff0000", cursor: "pointer" }} size="2xl" onClick={() => toggleEstado(row.idTipoDocumento)}
          />
        ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      compact: true
    }
  ];

const paginationOptionsES = {
  rowsPerPageText: 'Filas por página',
  rangeSeparatorText: 'de',
  selectAllRowsItem: true,
  selectAllRowsItemText: 'Todos',
};

  return (
    <div className="columns mt-5 is-centered">
      <div className="column is-half">
        <div className="notification is-primary">
          <strong>Ingresa el tipo de documento</strong>
        </div>

        <form onSubmit={createTipo}>
          <div className="field">
            <label className="label required">País</label>
            <div className="select is-fullwidth">
              <select value={idPais} onChange={e => setIdPais(e.target.value)} required>
                <option value="">Seleccionar</option>
                {paises.map(p => (
                  <option key={p.IdPais} value={p.IdPais}>{p.Nombre}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="field">
            <label className="label required">Tipo Documento</label>
            <div className="control">
              <input
                className="input"
                type="text"
                value={tipoDoc}
                onChange={e => setTipoDoc(e.target.value)}
                placeholder="Nombre"
                required
              />
            </div>
          </div>

          <button type="submit" className="button is-success">Guardar</button>
        </form>

        <br />

<div style={{ display: 'flex', gap: '10px', margin: '10px 0' }}>
  {["todas", "activas", "inactivas"].map((estado) => (
    <button
      key={estado}
      onClick={() => setFiltroEstado(estado)}
      type="button"
      style={{
        padding: "6px 16px",
        border: "none",
        borderRadius: "20px",
        backgroundColor: filtroEstado === estado ? "#d1f5d3" : "#f0f2f5",
        color: filtroEstado === estado ? "#075e54" : "#333",
        fontWeight: filtroEstado === estado ? "bold" : "normal",
        boxShadow:
          filtroEstado === estado
            ? "inset 0 0 0 1px #1ebea5"
            : "inset 0 0 0 1px #ccc",
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        fontSize: "0.9rem",
      }}
    >
      {estado.charAt(0).toUpperCase() + estado.slice(1)}
    </button>
  ))}
</div>


        <div style={{ border: "1px solid gray", borderRadius: "8px" }}>
         <DataTable pagination
          paginationComponentOptions={paginationOptionsES}
         columns={columns} data={filtrarTipos()} />
        </div>

        {selectedTipo && (
          <EditModal
            fields={editFields}
            initialValues={selectedTipo}
            onSubmit={handleEditTipoDocumento}
            title="Editar Tipo de Documento"
            onClose={() => setSelectedTipo(null)}
          />
        )}
      </div>
    </div>
  );
}